var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    className: "upload_svg__upload upload_svg__w-6 upload_svg__h-6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
  })));
}
export default __webpack_public_path__ + "static/media/upload.4e465cb3.svg";
export { SvgUpload as ReactComponent };